<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("Applied Certificate Detail") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div class="row">
        <div class="col-sm-12 p-0">
          <request-company-detail :companyId="companyId" :certificateId="certificateId"  :remove="classRemove"></request-company-detail>
        </div>
      </div>

    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../../app/Mixins/ModalMixin";
export default {
  name: "AppliedCertificateDetail",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
    certificateId: Number,
  },
  data() {
    return {
      classRemove: true,
      preloader: false,
      inputs: {
        yes: "no",
      },
      modalId: "demo-add-formbuilderbody-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    this.modalTitle = this.$t("Form Builder");
    this.preloader = true;
  },
  methods: {},
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
